import { useQuery } from '@tanstack/react-query';
import { schedulerMonitorApi } from '../api/schedulerMonitorApi';

/**
 * GET /scheduler-monitor/schedules — 등록 스케줄 작업 목록 (SCHEDULER_READ)
 * queryKey: ['scheduler-monitor', 'tasks']
 */
export function useScheduledTasks() {
  return useQuery({
    queryKey: ['scheduler-monitor', 'tasks'],
    queryFn: () => schedulerMonitorApi.listSchedules(),
    staleTime: 60_000,
  });
}
